import { Button, Form, Radio } from "antd";
import React from "react";

/** Demo */
const Demo: React.FC = () => {
    /** form 表单完成提交 */
    const onFinish = (val) => {
        console.log(val);
    };
    return (
        <Form initialValues={{ demo: '2', list: [{ a: '1', b: 2 }, { a: '2', b: 12 }] }} onFinish={onFinish}>
            <div>发生了什么</div>
            <Form.Item name="demo">
                <Radio.Group>
                    <Radio value="1">1</Radio>
                    <Radio value="2">2</Radio>
                    <Radio value="3">3</Radio>
                    <Radio value="4">4</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
            <Form.List name="list">
                {/* {fields =>
                    fields.map(({ key, name, fieldKey, ...resetFiled }) => (
                        <Form.Item key={key} name={[name, 'a']}>
                            <Radio.Group>
                                <Radio value="1">1</Radio>
                                <Radio value="2">2</Radio>
                                <Radio value="3">3</Radio>
                                <Radio value="4">4</Radio>
                            </Radio.Group>
                        </Form.Item>
                    ))
                } */}
                {() => [<Form.Item key={1} name={[0, 'a']}>
                            <Radio.Group>
                                <Radio value="1">1</Radio>
                                <Radio value="2">2</Radio>
                                <Radio value="3">3</Radio>
                                <Radio value="4">4</Radio>
                            </Radio.Group>
                        </Form.Item>, <Form.Item key={2} name={[1, 'a']}>
                            <Radio.Group>
                                <Radio value="1">1</Radio>
                                <Radio value="2">2</Radio>
                                <Radio value="3">3</Radio>
                                <Radio value="4">4</Radio>
                            </Radio.Group>
                        </Form.Item>]}
            </Form.List>
        </Form>
    );
};

export default Demo;